/**
 * Brand Configuration — White-label config for @3DCollective
 * All brand-specific values are centralized here for easy rebranding.
 */

const brandConfig = {
  // Identity
  name: '@3DCollective',
  shortName: '3DC',
  projectName: 'Romania Additive Strategy',
  logoInitials: 'RA',
  tagline: 'Strategic Technology for Romania\'s Industrial Future',

  // URLs
  website: 'https://3dcollective.ro',
  contactPhone: '+40 774 963 027',
  contactName: '3DCollective Romania',

  // SEO & Meta
  siteTitle: 'Romania Additive Strategy | @3DCollective',
  metaDescription: 'Strategic briefing on additive manufacturing opportunities in Romania — by @3DCollective.',

  // Colors (mirrored from design_guidelines.json for JS access)
  colors: {
    primary: '#002B49',
    accent: '#0066CC',
    background: '#FFFFFF',
    foreground: '#1F2937',
  },

  // Legal
  copyrightYear: 2025,
  get copyrightRo() {
    return `© ${this.copyrightYear} ${this.projectName}. Document strategic.`;
  },
  get copyrightEn() {
    return `© ${this.copyrightYear} ${this.projectName}. Strategic document.`;
  },

  // Assets
  assets: {
    favicon: '/favicon.ico',
  },
};

export default brandConfig;

